import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { REQUEST_ROUTES } from "../../constants";
import { HomePage } from "./HomePage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <HomePage />
      <SupportSheet
        namespace="request"
        visible
        onClose={() => navigate(REQUEST_ROUTES.HOME)}
      />
    </>
  );
});
